function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2 {\n                fill: currentColor;\n                stroke: currentColor;\n                stroke-width: .3px\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9006",
  "data-name": "Path 9006",
  className: "cls-2",
  d: "M54.549 48.051a1.08 1.08 0 0 0 .2.065v.245a.187.187 0 1 0 .373 0v-.23a.933.933 0 0 0 .24-.067.686.686 0 0 0 .414-.823.95.95 0 0 0-.76-.572c-.221-.065-.412-.12-.5-.272a.361.361 0 0 1-.005-.371.593.593 0 0 1 .993.2.187.187 0 0 0 .36-.1.944.944 0 0 0-.7-.641l-.042-.007V45.185a.187.187 0 0 0-.373 0V45.48a.787.787 0 0 0-.556.343.732.732 0 0 0 0 .762 1.1 1.1 0 0 0 .718.441c.278.081.451.14.508.325a.316.316 0 0 1-.207.37.636.636 0 0 1-.51-.013.608.608 0 0 1-.337-.353.187.187 0 0 0-.354.119.982.982 0 0 0 .538.577z",
  transform: "translate(-47.933 -40.648)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9007",
  "data-name": "Path 9007",
  className: "cls-2",
  d: "M94.791 32a.876.876 0 0 0-.846.656h-.466a.219.219 0 0 0-.133.045l-1.364 1.049h-.287a3.487 3.487 0 0 1 .215.437h.147a.219.219 0 0 0 .133-.045l1.363-1.048h.392A.874.874 0 1 0 94.791 32zm0 1.312a.437.437 0 1 1 .437-.437.437.437 0 0 1-.437.437z",
  transform: "translate(-81.666 -29.375)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9008",
  "data-name": "Path 9008",
  className: "cls-2",
  d: "M94.791 76.437a.876.876 0 0 0-.846.656h-.392l-1.363-1.048a.219.219 0 0 0-.134-.045h-.147a3.488 3.488 0 0 1-.215.437h.287l1.363 1.048a.219.219 0 0 0 .133.045h.466a.874.874 0 1 0 .846-1.094zm0 1.312a.437.437 0 1 1 .437-.437.437.437 0 0 1-.437.438z",
  transform: "translate(-81.666 -68.563)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9009",
  "data-name": "Path 9009",
  className: "cls-2",
  d: "M98.563 56a.876.876 0 0 0-.846.656h-1.786c0 .072.008.145.008.219s0 .146-.008.219h1.786A.874.874 0 1 0 98.563 56zm0 1.312a.437.437 0 1 1 .437-.437.437.437 0 0 1-.437.437z",
  transform: "translate(-85.438 -50.75)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9010",
  "data-name": "Path 9010",
  className: "cls-2",
  d: "M.875 57.756a.876.876 0 0 0 .846-.656h1.786c0-.072-.008-.145-.008-.219s0-.146.008-.219H1.721a.874.874 0 1 0-.846 1.094zm0-1.312a.437.437 0 1 1-.437.437.437.437 0 0 1 .437-.437z",
  transform: "translate(.001 -50.756)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9011",
  "data-name": "Path 9011",
  className: "cls-2",
  d: "M2.312 32.7a.219.219 0 0 0-.133-.045h-.466a.875.875 0 1 0 0 .437H2.1l1.363 1.048a.219.219 0 0 0 .133.045h.147a3.488 3.488 0 0 1 .215-.437h-.283zm-1.446.611a.437.437 0 1 1 .437-.437.437.437 0 0 1-.437.437z",
  transform: "translate(.009 -29.375)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9016",
  "data-name": "Path 9016",
  className: "cls-2",
  d: "M.875 78.187a.876.876 0 0 0 .846-.656h.466a.219.219 0 0 0 .133-.045l1.363-1.048h.287A3.488 3.488 0 0 1 3.756 76h-.147a.219.219 0 0 0-.133.045l-1.364 1.049h-.391a.874.874 0 1 0-.846 1.094zm0-1.312a.437.437 0 1 1-.437.437.437.437 0 0 1 .437-.437z",
  transform: "translate(.001 -68.563)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9017",
  "data-name": "Path 9017",
  className: "cls-2",
  d: "M13.78 108a.219.219 0 0 0-.219.219v1.094a.438.438 0 0 1-.437.437H.875a.438.438 0 0 1-.437-.437v-.219a.219.219 0 0 0-.437 0v.219a.876.876 0 0 0 .875.875h12.248a.876.876 0 0 0 .875-.875v-1.094a.219.219 0 0 0-.219-.219z",
  transform: "translate(.001 -97.938)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9018",
  "data-name": "Path 9018",
  className: "cls-2",
  d: "M13.124 0H.875A.876.876 0 0 0 0 .875v1.094a.219.219 0 0 0 .437 0V.875A.438.438 0 0 1 .875.437h12.249a.438.438 0 0 1 .437.437v.219a.219.219 0 0 0 .437 0V.875A.876.876 0 0 0 13.124 0z",
  transform: "translate(.001)"
});

function SvgCloudwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.92,
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "ic-mediatalr",
    transform: "translate(.152 .15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9005",
    "data-name": "Path 9005",
    d: "M39 42a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-5.571A2.571 2.571 0 1 1 36.429 39 2.571 2.571 0 0 1 39 36.429z",
    transform: "translate(-32.062 -32.938)",
    style: {
      fill: "currentColor"
    }
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudwatch);
export default __webpack_public_path__ + "static/media/cloudwatch.09e034a0.svg";
export { ForwardRef as ReactComponent };